import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, Injectable } from '@angular/core';
import FilterList, { FilterValues } from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';

@Injectable({
	providedIn: 'root',
})
@Pipe({
	name: 'filter-table',
})
export class FilterTablePipe implements PipeTransform {
	constructor(private datePipe: DatePipe) {}

	transform(value: any[], ...args: any[]): unknown {
		if (args.length === 0) {
			return value;
		}

		const rowsCopy: { [key: string]: any }[] = value;
		const filterList = args[0];

		const result = rowsCopy.filter((row) => {
			return filterList.every((item: FilterValues) => {
				if (item.value) {
					if (item.type === 'date') {
						let date = new Date(item.value);
						date.setDate(date.getDate() + 1);
						const dateString = this.datePipe.transform(date, 'yyyy-MM-dd');
						return this.datePipe.transform(row[item.key], 'yyyy-MM-dd') === dateString;
					}

					if (item.type === 'select') {
						return row[item.key].toLowerCase() === item.value.toLocaleLowerCase();
					}

					if (typeof row[item.key] === 'number' || item.type === 'number') {
						return row[item.key].toString().startsWith(item.value);
					}

					return row[item.key].toLowerCase().includes(item.value.toLocaleLowerCase());
				}
				return false;
			});
		});

		return result;
	}
}
